import Contact1 from './Contact1'
export default Contact1
